import { render } from "./BerichteList.pug?vue&type=template&id=5b5bd29e&lang=pug"
import script from "./BerichteList.js?vue&type=script&lang=js"
export * from "./BerichteList.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__